import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span>🇨🇦 Trusted Immigration Consultant</span>
            </div>
            <h1 className="hero-title">
              <span className="title-line">Your <span className="highlight">Canadian</span> Immigration</span>
              <span className="title-line">Journey Starts Here</span>
            </h1>
            <p className="hero-subtitle">
              Professional guidance by Licensed RCIC Lisa Halliwell, Charlottetown, PE
            </p>
            <p className="hero-description">
              Canadian Umbrella Immigration Services Inc. provides professional, reliable, and personalized immigration services 
              to individuals, families, students, and businesses across Canada.
            </p>
            {/* Features */}
            {/* Replace Icons with images*/}
            <div className="hero-features">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="/RCICIRB-removebg-preview.png" alt="RCIC-IRB Logo" />
                </div>
                <span>Regulated Canadian Immigration Consultants (RCIC)</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="/CAPICnew.png" alt="CAPIC Logo" />
                </div>
                <span>Member of Canadian Association of Professional Immigration Consultants</span>
              </div>
            </div>
            <div className="hero-buttons">
              <Link to="/book-consultation" className="btn btn-primary">
                <span>Start Your Journey</span>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
              </Link>
              <Link to="/services" className="btn btn-secondary">
                <span>Our Services</span>
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <h3>Our Approach</h3>
              </div>
              <div className="card-content">
                <div className="approach-points">
                  <div className="approach-point">
                    <span className="point-number">1</span>
                    <span>Initial Consultation</span>
                  </div>
                  <div className="approach-point">
                    <span className="point-number">2</span>
                    <span>Personalized Strategy</span>
                  </div>
                  <div className="approach-point">
                    <span className="point-number">3</span>
                    <span>Ongoing Support</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">Our Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="process-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3>Initial Consultation</h3>
              <p>Consultation to assess your eligibility and discuss your immigration goals.</p>
            </div>
            <div className="process-step">
              <div className="process-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h3>Documentation</h3>
              <p>We help you gather and prepare necessary documents for your application.</p>
            </div>
            <div className="process-step">
              <div className="process-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"/>
                </svg>
              </div>
              <h3>Application Submission</h3>
              <p>We assist with submitting your application and ensuring requirements are met.</p>
            </div>
            <div className="process-step">
              <div className="process-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2.01 1l-3.99 5.33V22h-2v-8.67L8.01 9A2.01 2.01 0 0 0 6.01 8H3.46c-.8 0-1.54.37-2.01 1L1.5 15.37A1.5 1.5 0 0 0 3.46 18H6v6h2v-8.67L12 9l4 5.33V22h2z"/>
                </svg>
              </div>
              <h3>Ongoing Support</h3>
              <p>We provide support and updates throughout the process.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="container">
          <h2 className="section-title">Immigration Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Permanent Resident Applications</h3>
              <p>Comprehensive support for permanent residency including Express Entry, Family Sponsorship, and Provincial Nominee Programs.</p>
              <Link to="/services" className="service-link">Learn More →</Link>
            </div>
            <div className="service-card">
              <h3>Temporary Resident Applications</h3>
              <p>Assistance with visitor visas, work permits, study permits, and extending your stay in Canada.</p>
              <Link to="/services" className="service-link">Learn More →</Link>
            </div>
            <div className="service-card">
              <h3>Other Services</h3>
              <p>Support for refusal reviews, reconsideration requests, citizenship applications, and PR card renewals.</p>
              <Link to="/services" className="service-link">Learn More →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Canadian Journey?</h2>
            <p>Book a consultation with Lisa Halliwell, RCIC at Canadian Umbrella Immigration Services in Charlottetown, PE, to discuss your options and begin your immigration process.</p>
            <Link to="/book-consultation" className="btn btn-primary btn-large">
              Book Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 